import { isNotDefined } from '@sgme/fp';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';

import { useFlexiForwardSelector } from '@/App/tiles/FlexiForward/FlexiForwardContext.ts';
import { useCheckFlexiForwardByTradeCaptureMutation } from '@/store/flexi-forward/api';
import type { FlexiForwardProperties } from '@/store/flexi-forward/state.ts';

/**
 * Hook générique pour créer un handler qui appelle checkFlexiForward avec des propriétés dérivées de la valeur reçue.
 *
 * @param tileId - Identifiant du tile
 * @param analyticsLabel - Libellé de l'événement analytics
 * @param toProperties - Fonction qui transforme la valeur reçue en propriétés FlexiForward
 */
export function useFlexiForwardPropertyChangedHandler<T>(
  tileId: string,
  analyticsLabel: string,
  toProperties: (value: T) => FlexiForwardProperties,
): (value: T) => void {
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const tradeCapture = useFlexiForwardSelector((flexiForward) => flexiForward.tradeCapture);

  const [checkFlexiForward] = useCheckFlexiForwardByTradeCaptureMutation();

  return function handlePropertyChanged(value: T) {
    sgwtWebAnalytics?.trackEvent('Flexi Forward', analyticsLabel, `${value}`);

    if (isNotDefined(tradeCapture)) {
      return;
    }

    checkFlexiForward({
      tileId,
      tradeCapture,
      properties: toProperties(value),
    });
  };
}
